import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {AppComponent} from './app.component';
import {TextBoxComponent} from './renderer/components/text-box/text-box.component';
import {RendererComponent} from './renderer/renderer.component';
import {MatSelectModule} from '@angular/material/select';
import {MatInputModule} from '@angular/material/input';
import {MatIconModule} from '@angular/material/icon';
import {BrowserAnimationsModule, NoopAnimationsModule} from "@angular/platform-browser/animations";
import {GroupComponent} from "./renderer/components/group/group.component";
import {DynamicComponentBuilder} from "./renderer/dynamic-component-builder.service";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {HttpClientModule} from "@angular/common/http";
import {InfoComponent} from "./renderer/components/info/info.component";
import {MatCardModule} from "@angular/material/card";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {AppEditorComponent} from "./editor/app.editor.component";
import {AppRendererComponent} from "./renderer/app.renderer.component";
import {DragDropModule} from "@angular/cdk/drag-drop";
import {AppRoutingModule} from "./app-routing.module";
import {MatMenuModule} from "@angular/material/menu";
import {MatButtonModule} from "@angular/material/button";
import {MatToolbarModule} from "@angular/material/toolbar";
import {DataHistoryComponent} from "./editor/data.history.component";
import {JsonEditorComponent} from "./editor/json.editor.component";
import {CalendarComponent} from "./renderer/components/calendar/calendar.component";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatNativeDateModule} from "@angular/material/core";
import {TextAreaComponent} from "./renderer/components/text-area/text-area.component";
import {TreeEditorComponent} from "./editor/tree.editor.component";
import {SamplesComponent} from "./renderer/components/samples.component";
import {MatSidenavModule} from "@angular/material/sidenav";
import {MatListModule} from "@angular/material/list";
import {EditFormComponent} from "./editor/edit.form.component";
import {MatDialogModule} from "@angular/material/dialog";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {MatButtonToggleModule} from "@angular/material/button-toggle";
import {MatGridListModule} from "@angular/material/grid-list";
import {PredefinedValidatorsComponent} from "./renderer/validators/predefined.validators.component";
import {MatTableModule} from "@angular/material/table";
import {PredefinedOptionsComponent} from "./renderer/options/predefined.options.component";
import {MatTreeModule} from "@angular/material/tree";
import {AbstractEditorComponent} from "./editor/abstract.editor.component";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatSliderModule} from "@angular/material/slider";

@NgModule({
    imports: [BrowserModule, HttpClientModule,
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        // material
        MatSelectModule, MatInputModule, MatIconModule, NoopAnimationsModule, ReactiveFormsModule, MatCardModule,
        MatIconModule, MatCheckboxModule, FormsModule,
        DragDropModule, MatMenuModule, MatButtonModule, MatToolbarModule, MatDatepickerModule, MatNativeDateModule,
        MatSidenavModule, MatListModule, MatListModule, MatDialogModule, MatSlideToggleModule, MatButtonToggleModule,
        MatGridListModule, MatTableModule, MatTreeModule, MatTooltipModule, MatSliderModule],
    declarations: [AppComponent,
        AppRendererComponent,
        AppEditorComponent,
        EditFormComponent,
        PredefinedValidatorsComponent,
        PredefinedOptionsComponent,
        DataHistoryComponent,
        JsonEditorComponent,
        TreeEditorComponent,
        SamplesComponent,
        SamplesComponent,
        AbstractEditorComponent,
        AppRendererComponent,
        RendererComponent,
        TextBoxComponent,
        GroupComponent,
        CalendarComponent,
        InfoComponent,
        TextAreaComponent],
    entryComponents: [AppRendererComponent, EditFormComponent, PredefinedValidatorsComponent, PredefinedOptionsComponent,
        TextBoxComponent, GroupComponent, InfoComponent, CalendarComponent, TextAreaComponent],
    providers: [DynamicComponentBuilder],
    bootstrap: [AppComponent]
})
export class AppModule {
    constructor() {
    }
}
